<template>
    <AppHeader v-bind="$attrs" :appKey="appKey">
        <template v-slot:appActions>
            <Disclaimer
                    text="Use this switch to toggle between Group A (Control) and Group B (Test)"
                    :uniqueId="uniqueId"
                    placement="bottom">
                <Switcher
                        class="middleAlign tas-ab-switcher"
                        :uniqueId="`abSwitch_${appKey}`"
                        :isDisabled="!abSwitcherEnabled"
                        :isActive="isA"
                        :styles="{look: 'ab', label: 'small'}"
                        iconDisplay="flex"
                        @changed="selectABSwitcher"
                ></Switcher>
            </Disclaimer>
        </template>
        <template v-for="(index, name) in $slots" v-slot:[name]>
            <slot :name="name" />
        </template>
    </AppHeader>
</template>

<script>
import Switcher from 'components/Switcher.vue';
import Disclaimer from 'components/disclaimer/Disclaimer.vue';
import AppHeader from './AppHeader.vue';

export default {
    name: 'ABAppHeader',
    components: { Switcher, AppHeader, Disclaimer },
    props: {
        abSwitcherEnabled: {
            type: Boolean,
            default: true
        },
        isA: Boolean,
        appKey: String,
        uniqueId: {
            type: String,
            required: true
        }
    },
    methods: {
        selectABSwitcher(value) {
            // todo: vuex for ab persistency
            this.$emit('abChanged', value);
        }
    }
};
</script>

<style scoped lang="scss">
    @import "~styles/styleGuide";

    .popover {
        display: inline-block;
        margin-left: 5px;
    }

    .disclaimer {
        max-width: 210px;
        display: grid;
        grid-template-columns: auto 70px;
    }

    .disclaimer-text {
        grid-column-start: 1;
        grid-column-end: 3;
    }

    .disclaimer-button {
        grid-column-start: 2;
        margin-top: 10px;
    }

    .tas-ab-switcher {
        margin-left: 3px;
        // adjust switcher position and size
        ::v-deep .middle {
            margin-top: -5px;
            width: 38px;
        }
    }

</style>
